import { State } from 'store/state';
import { SearchViewMode, DEFAULT_SEARCH_VIEW } from 'components/list-view-switcher/constants';

export function maybeApplySearchView(state: State, view: SearchViewMode): State {
  const searchViewMode = view ? { intermediateValue: null, committedValue: view } : DEFAULT_SEARCH_VIEW;
  return {
    ...(state || null),
    app: {
      ...(state && state.app || null),
      searchViewMode,
    },
  };
}
